import Index from '@/views/admin/Index.vue';
// import exhibitor from '@/router/admin/exhibitor';
// import buyer from '@/router/admin/buyer';
// import component from '@/router/admin/component';
// import test from '@/router/admin/test';
import admin from '@/router/admin/admin';
import Home from '@/views/admin/Home.vue';

const defaultRouters: any[] = [
  {
    name: 'admin-home',
    path: '',
    component: Home,
    meta: {
      title: 'メニュー',
    },
  },
];

const children: any[] = defaultRouters
  // .concat(exhibitor.routes)
  // .concat(buyer.routes)
  // .concat(component.routes)
  .concat(admin.routes);
  // .concat(test.routes);

const routes: any[] = [
  {
    path: '/admin',
    component: Index,
    children,
  },
];

export default {
  routes,
};
